module.exports = __webpack_public_path__ + "static/media/recommendedf2.b84a014c.png";